var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CreateUserDocument, SearchUserDocument, UserpoolDocument, UpdateUserpoolDocument, ResetPasswordDocument, CheckPasswordStrengthDocument, RegisterByEmailDocument, RegisterByUsernameDocument, AssignRoleDocument, IsActionAllowedDocument, IsActionDeniedDocument, CreateRoleDocument, LoginByEmailDocument, LoginByUsernameDocument, LoginByPhoneCodeDocument, LoginByPhonePasswordDocument, OrgDocument, AddMemberDocument, SendEmailDocument, UsersDocument, UserDocument, RolesDocument, GroupsDocument, UpdateUserDocument, DeleteUserDocument, DeleteUsersDocument, RoleDocument, RoleWithUsersDocument, UpdateRoleDocument, OrgsDocument, CreateOrgDocument, AddNodeDocument, UpdateNodeDocument, DeleteNodeDocument, MoveNodeDocument, NodeByIdWithMembersDocument, NodeByCodeWithMembersDocument, RemoveMemberDocument, RevokeRoleDocument, ChildrenNodesDocument, RefreshTokenDocument, AddUserToGroupDocument, RegisterByPhoneCodeDocument, UpdatePasswordDocument, UpdatePhoneDocument, UpdateEmailDocument, BindPhoneDocument, UnbindPhoneDocument, UserBatchDocument, GetUserRolesDocument, AllowDocument, WhitelistDocument, RemoveWhitelistDocument, AddWhitelistDocument, UdfDocument, UdvDocument, SetUdvDocument, RemoveUdvDocument, SetUdfDocument, RemoveUdfDocument, DeleteRoleDocument, DeleteRolesDocument, PoliciesDocument, CreatePolicyDocument, PolicyDocument, UpdatePolicyDocument, DeletePolicyDocument, DeletePoliciesDocument, PolicyAssignmentsDocument, AddPolicyAssignmentsDocument, RemovePolicyAssignmentsDocument, DeleteOrgDocument, RootNodeDocument, IsRootNodeDocument, IsUserExistsDocument, CheckLoginStatusDocument, GroupDocument, CreateGroupDocument, UpdateGroupDocument, DeleteGroupsDocument, RemoveUserFromGroupDocument, GroupWithUsersDocument, GetUserGroupsDocument, UnbindEmailDocument, AccessTokenDocument } from '../types/graphql.v2';
export var isAllowed = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsActionAllowedDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getChildrenNodes = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ChildrenNodesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var org = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = OrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var isRootNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsRootNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var rootNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RootNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var orgs = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = OrgsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getUserPoolDetail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserpoolDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var user = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var createOrg = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateOrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var deleteOrg = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteOrgDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var isDenied = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsActionDeniedDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var checkPasswordStrength = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CheckPasswordStrengthDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var registerByEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RegisterByEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var loginByEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByEmailDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByUsername = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByUsernameDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByPhoneCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByPhoneCodeDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var loginByPhonePassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = LoginByPhonePasswordDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var registerByUsername = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = RegisterByUsernameDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var registerByPhoneCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        query = RegisterByPhoneCodeDocument;
        token = tokenProvider.getToken();
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                token: token,
                variables: variables
            })];
    });
}); };
export var addRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var assignRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AssignRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var revokeRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RevokeRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var addMember = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddMemberDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getMembersById = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = NodeByIdWithMembersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getMembersByCode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = NodeByCodeWithMembersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var sendEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SendEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var resetPassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = ResetPasswordDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var users = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateUserpool = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateUserpoolDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var searchUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SearchUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteUser = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteUserDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var roles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var role = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var roleWithUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RoleWithUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var moveNode = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = MoveNodeDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeMembers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveMemberDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var refreshToken = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RefreshTokenDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var isUserExists = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = IsUserExistsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePassword = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePasswordDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var bindPhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = BindPhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var unbindPhone = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UnbindPhoneDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var userBatch = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UserBatchDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getUserRoles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GetUserRolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var allow = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AllowDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = WhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveWhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addWhiteList = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddWhitelistDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var udv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUdv = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUdvDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var setUdf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = SetUdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUdf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var udf = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UdfDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteRole = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteRoleDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteRoles = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteRolesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policies = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PoliciesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createPolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreatePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updatePolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdatePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deletePolicy = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeletePolicyDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deletePolicies = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeletePoliciesDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var policyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = PolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addPolicyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddPolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removePolicyAssignments = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemovePolicyAssignmentsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var checkLoginStatus = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CheckLoginStatusDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var group = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var groupWithUsers = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GroupWithUsersDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var createGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = CreateGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var updateGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UpdateGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var deleteGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = DeleteGroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var addUserToGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = AddUserToGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var removeUserFromGroup = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = RemoveUserFromGroupDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getUserGroups = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = GetUserGroupsDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var unbindEmail = function (garpqhlClient, tokenProvider, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = UnbindEmailDocument;
                return [4 /*yield*/, tokenProvider.getToken()];
            case 1:
                token = _a.sent();
                return [2 /*return*/, garpqhlClient.request({
                        query: query,
                        token: token,
                        variables: variables
                    })];
        }
    });
}); };
export var getAccessToken = function (garpqhlClient, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query;
    return __generator(this, function (_a) {
        query = AccessTokenDocument;
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                variables: variables
            })];
    });
}); };
export var refreshAccessToken = function (garpqhlClient, variables) { return __awaiter(void 0, void 0, void 0, function () {
    var query;
    return __generator(this, function (_a) {
        query = RefreshTokenDocument;
        return [2 /*return*/, garpqhlClient.request({
                query: query,
                variables: variables
            })];
    });
}); };
//# sourceMappingURL=data:application/json;base64,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